"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importStar(require("react"));
const sub_layout_1 = require("../../../../layouts/sub-layout");
const core_1 = require("@material-ui/core");
const react_redux_1 = require("react-redux");
const lab_1 = require("@material-ui/lab");
const actions_1 = require("../../../actions/actions");
const themes_1 = require("../../../../utils/themes");
const pre_processing_step1_1 = require("../subSteps/preProcessing/pre-processing-step1");
const pre_processing_step2_1 = require("../subSteps/preProcessing/pre-processing-step2");
const pre_processing_step3_1 = require("../subSteps/preProcessing/pre-processing-step3");
const pre_processing_step4_1 = require("../subSteps/preProcessing/pre-processing-step4");
const pre_processing_step3_Anomaly_1 = require("../subSteps/preProcessing/pre-processing-step3-Anomaly");
const pre_processing_step4_Anomaly_1 = require("../subSteps/preProcessing/pre-processing-step4-Anomaly");
const pre_processing_step5_Anomaly_1 = require("../subSteps/preProcessing/pre-processing-step5-Anomaly");
const pre_processing_step3_rca_ms_1 = require("../subSteps/preProcessing/pre-processing-step3-rca_ms");
const pre_processing_step4_rca_ms_1 = require("../subSteps/preProcessing/pre-processing-step4-rca_ms");
const api_1 = require("../../../../utils/api");
const react_spinners_1 = require("react-spinners");
const style_1 = tslib_1.__importDefault(require("src/app/auto-ml/utils/style"));
const js_cookie_1 = tslib_1.__importDefault(require("js-cookie"));
const Icons_1 = require("../../../../../../components/Icons");
function PreProcessing(props) {
    const dispatch = react_redux_1.useDispatch();
    const mainStep = react_redux_1.useSelector((state) => state.mainStep.no);
    const columnDataFromRedux = react_redux_1.useSelector((state) => state.columnSelectionS22);
    const [columnData, setColumnData] = react_1.useState(columnDataFromRedux);
    const handlingMissingValues = react_redux_1.useSelector((state) => state.handlingMissingValues);
    const projectInfo = react_redux_1.useSelector((state) => state.ProjectInfo);
    const binaryThresholding = react_redux_1.useSelector((state) => state.binary_thresholding);
    const featureMapping = react_redux_1.useSelector((state) => state.feature_mapping_data);
    const styleLocal = style_1.default();
    react_1.useEffect(() => {
        if (columnData.warning) {
            showToast(columnData.warning);
        }
    }, []);
    react_1.useEffect(() => {
        setSubStepData(subSteppers[projectInfo.problemtype]);
    }, [projectInfo]);
    react_1.useEffect(() => {
        localStorage.setItem('pageFlag', 2);
    }, []);
    const handleCloseSnackbar = () => {
        setSnackbarOpen(false);
    };
    const showToast = (message) => {
        setSnackbarMessage(message);
        setSnackbarType("warning");
        setSnackbarOpen(true);
    };
    const subSteppers = {
        regression: [
            { required: true, text: "Visualization Table", active: true },
            { required: true, text: "Select Column Type", active: false },
            { required: false, text: "Handling missing values", active: false },
            { required: false, text: "Outlier removal", active: false },
        ],
        eventclassification: [
            { required: true, text: "Visualization Table", active: true },
            { required: true, text: "Select Column Type", active: false },
            { required: false, text: "Handling missing values", active: false },
        ],
        RootCauseAnalysis: [
            { required: true, text: "Visualization Table", active: true },
            { required: true, text: "Select Column Type", active: false },
            { required: false, text: "Handling missing values", active: false },
        ],
        rca_ms: [
            { required: false, text: "Visualization Table", active: true },
            { required: false, text: "Select Column Type", active: false },
            { required: false, text: "Column Binarizing", active: false },
            { required: false, text: "Feature Mapping", active: false },
        ],
        anomalydetection: [
            { required: true, text: "Visualization Table", active: true },
            { required: true, text: "Select Column Type", active: false },
            { required: false, text: "Interpolate dataset", active: false },
            { required: false, text: "Handle Missing Values", active: false },
            { required: false, text: "Create Lag Variables", active: false },
        ]
    };
    for (let key in subSteppers) {
        subSteppers[key] = subSteppers[key].map(step => {
            if (step.required) {
                step.text = (react_1.default.createElement(react_1.default.Fragment, null,
                    step.text,
                    " ",
                    react_1.default.createElement("span", { style: { color: "red" } }, "*")));
            }
            return step;
        });
    }
    const [currentStep, setCurrentStep] = react_1.useState(0);
    const [updatedColumnData, setUpdatedColumnData] = react_1.useState(columnDataFromRedux);
    const [updatedInterpolateData, setUpdatedInterpolateData] = react_1.useState(columnDataFromRedux);
    const [lagVariablesDataMain, setLagVariablesDataMain] = react_1.useState(columnDataFromRedux);
    const [updatedMissingColumnData, setUpdatedMissingColumnData] = react_1.useState(handlingMissingValues);
    const [outlierRemovalMethod, setOutlierRemovalMethod] = react_1.useState();
    const [isVisualizeButton, setIsVisualizeButton] = react_1.useState(false);
    const [isVisualizeTable, setIsVisualizeTable] = react_1.useState(false);
    const [visualizationTable, setVisualizationTable] = react_1.useState([]);
    const [visualizationImgs, setVisualizationImgs] = react_1.useState(null);
    const [isVisualizationFinal, setIsVisualizationFinal] = react_1.useState(false);
    const [subStepperData, setSubStepData] = react_1.useState(null);
    const [loading, setLoading] = react_1.useState(false);
    const [errorMessage, setErrorMessage] = react_1.useState("");
    const [interpolationFrequencyError, setInterpolationFrequencyError] = react_1.useState("");
    const [lagVariablesCountError, setLagVariablesCountError] = react_1.useState("");
    const [lagVariablesColumnError, setLagVariablesColumnError] = react_1.useState("");
    const [updateBinaryThresholding, setBinaryThresholding] = react_1.useState(binaryThresholding);
    const [updateFeatureMapping, setFeatureMapping] = react_1.useState({});
    const [configureColumnValue, setConfigureColumnValue] = react_1.useState({});
    const [featureMapColumn, setFeatureMapColumn] = react_1.useState([]);
    const [dataTransformColumn, setDataTransformColumn] = react_1.useState([]);
    const [categoricalColumn, setCategoricalColumn] = react_1.useState([]);
    const [remainingColumnError, setRemainingColumnError] = react_1.useState("");
    const isMounted = react_1.useRef(true);
    const [editingRowId, setEditingRowId] = react_1.useState(null);
    const [editError, setEditError] = react_1.useState("");
    const [snackbarOpen, setSnackbarOpen] = react_1.useState(false);
    const [snackbarMessage, setSnackbarMessage] = react_1.useState("");
    const [snackbarType, setSnackbarType] = react_1.useState("");
    const [columnNameError, setColumnNameError] = react_1.useState("");
    react_1.useEffect(() => {
        return () => {
            isMounted.current = false;
        };
    }, []);
    const validateFields = (step, index) => {
        switch (step) {
            case "selectColumns":
                if (!updatedColumnData.selectedTargetColumn && updatedColumnData.selectedTargetColumn.length) {
                    setErrorMessage("Please add a target column");
                    return false;
                }
                break;
            case "interpolate":
                if (!updatedInterpolateData.interpolationFrequency) {
                    setInterpolationFrequencyError("Please add an interpolation frequency");
                    return false;
                }
                break;
            case "lagVariables":
                const { no_ofLagVariables, lagVariablesColumn } = lagVariablesDataMain;
                let isValid = true;
                if (!no_ofLagVariables) {
                    setLagVariablesCountError("Please add a lag variables count");
                    isValid = false;
                }
                if (!lagVariablesColumn && lagVariablesColumn.length) {
                    setLagVariablesColumnError("Please add a lag variables column");
                    isValid = false;
                }
                return isValid;
            case "checkrca_ms":
                if (!(updatedColumnData.selectedIndexColumns && updatedColumnData.selectedIndexColumns.length) && index == 1) {
                    setErrorMessage("Please add an index column");
                    return false;
                }
                if (updatedColumnData.remainingColumns.length != 0) {
                    setRemainingColumnError("Please remove all column from remaining column field.");
                    return false;
                }
                if ((index == 2) && (!updateBinaryThresholding && updateBinaryThresholding.categorical ||
                    Object.keys(updateBinaryThresholding.categorical).length !== categoricalColumn.length)) {
                    setErrorMessage("Categorical Fields are Required");
                    return false;
                }
                if (updateBinaryThresholding.categorical && index == 2) {
                    const categorical = updateBinaryThresholding.categorical;
                    for (const key in categorical) {
                        if (categorical[key] & categorical[key].ones &&
                            Array.isArray(categorical[key].ones) &&
                            categorical[key].ones.length === 0) {
                            setErrorMessage(`Unique values to be mapped to 1 shold not be empty.`);
                            return false;
                        }
                    }
                }
                if (editingRowId != null) {
                    setEditError("Please save your changes before proceeding.");
                    return false;
                }
                break;
            default:
                return true;
        }
        return true;
    };
    const setCurrentStepByClick = (step) => {
        if (step >= 0 && step < subStepperData.length && step <= currentStep) {
            const updatedSubStepperData = subStepperData.map((item, index) => (Object.assign({}, item, { active: index <= step })));
            setSubStepData(updatedSubStepperData);
            setCurrentStep(step);
            setIsVisualizeButton(false);
            setIsVisualizeTable(false);
            setIsVisualizationFinal(false);
        }
    };
    const increaseStep = () => tslib_1.__awaiter(this, void 0, void 0, function* () {
        setLoading(true);
        let lastIndex = 0;
        subStepperData.map((d, i) => {
            if (d.active === true) {
                lastIndex = i;
            }
        });
        try {
            if (lastIndex === 1) {
                if (projectInfo.problemtype === "rca_ms") {
                    if (!validateFields("checkrca_ms", 1)) {
                        console.log("Please select a valid field");
                        return;
                    }
                    const rcaColumnSelectionData = {
                        projectname: projectInfo.projectname,
                        problemtype: projectInfo.problemtype,
                        version_name: projectInfo.version_name,
                        userid: js_cookie_1.default.get('USER_ID'),
                        select_column_type: {
                            categorical: updatedColumnData.selectedCategoricalColumns,
                            numerical: updatedColumnData.selectedNumericalColumns,
                            index: updatedColumnData.selectedIndexColumns,
                            dropcolumns: updatedColumnData.selectedDropColumns ? updatedColumnData.selectedDropColumns : [],
                            remainingcolumns: updatedColumnData.remainingColumns,
                        }
                    };
                    console.log("sddsfsfsdfsf", updatedColumnData);
                    console.log("before saving updatedcolum", binaryThresholding);
                    dispatch(actions_1.saveColumnSelectionS22(updatedColumnData));
                    console.log("after saving updatedcolum", binaryThresholding);
                    const rcaSelectColumnRes = yield api_1.selectColumnType(rcaColumnSelectionData);
                    console.log("after sending req updatedcolum", binaryThresholding);
                    const selectedKeys = updatedColumnData.selectedCategoricalColumns;
                    // To store the first occurrence
                    const dataMap = new Map();
                    rcaSelectColumnRes.data.non_binarized_categorical.forEach(obj => {
                        selectedKeys.forEach(key => {
                            if (obj[key] !== undefined && !dataMap.has(key)) {
                                dataMap.set(key, obj[key]); // Store the first occurrence
                            }
                        });
                    });
                    console.log('before', categoricalColumn);
                    const column = rcaSelectColumnRes.data.non_binarized_categorical.map(value => Object.keys(value)[0]);
                    if (isMounted.current) {
                        setConfigureColumnValue(Object.fromEntries(dataMap));
                        setCategoricalColumn(column);
                    }
                    console.log('after', column);
                }
                else {
                    if (!validateFields("selectColumns", 1)) {
                        console.log("Please select a valid field");
                        return;
                    }
                    const column_selection_data = {
                        projectname: projectInfo.projectname,
                        problemtype: projectInfo.problemtype,
                        version_name: projectInfo.version_name,
                        userid: js_cookie_1.default.get('USER_ID'),
                        select_column_type: {
                            categorical: updatedColumnData.selectedCategoricalColumns,
                            numerical: updatedColumnData.selectedNumericalColumns,
                            target: updatedColumnData.selectedTargetColumn,
                            datetimecolumns: updatedColumnData.selectedDateTime,
                            remainingcolumns: updatedColumnData.remainingColumns,
                        }
                    };
                    dispatch(actions_1.saveColumnSelectionS22(updatedColumnData));
                    const selectColumnRes = yield api_1.selectColumnType(column_selection_data);
                    dispatch(actions_1.nullValueColumns(selectColumnRes.data.null_percentage));
                    const handlingMissingValues = {
                        selectedCategoricalRemoveColumns: [],
                        selectedCategoricalReplaceWithMode: [],
                        selectedCategoricalRemoveRows: [],
                        categoricalRemainingColumns: updatedColumnData.selectedCategoricalColumns.map(String),
                        selectedNumericalRemoveColumns: [],
                        selectedNumericalReplaceWithZero: [],
                        selectedNumericalReplaceWithMean: [],
                        selectedNumericalReplaceWithMedian: [],
                        selectedNumericalReplaceWithMode: [],
                        selectedNumericalRemoveRows: [],
                        numericalRemainingColumns: updatedColumnData.selectedNumericalColumns.map(String),
                        selectedTargetReplaceWithMode: [],
                        selectedTargetRemoveRows: [],
                        targetRemainingColumns: updatedColumnData.selectedTargetColumn.map(String),
                        selectedDateTimeRemoveRows: [],
                        dateTimeRemainingColumns: updatedColumnData.selectedDateTime.map(String),
                    };
                    dispatch(actions_1.saveHandlingMissingValues(handlingMissingValues));
                }
            }
            else if (lastIndex === 2) {
                if (projectInfo.problemtype === "rca_ms") {
                    console.log("rca values", updateBinaryThresholding);
                    if (!validateFields("checkrca_ms", 2)) {
                        console.log("Please select catagorical");
                        return;
                    }
                    dispatch(actions_1.updateBinaryThresholdingData(updateBinaryThresholding));
                    const binary_thresholding_data = {
                        projectname: projectInfo.projectname,
                        problemtype: projectInfo.problemtype,
                        version_name: projectInfo.version_name,
                        userid: js_cookie_1.default.get('USER_ID'),
                        binary_thresholding: {
                            categorical: updateBinaryThresholding.categorical,
                            numerical: updateBinaryThresholding.numerical
                        }
                    };
                    if (editError != "") {
                        setSnackbarOpen(true);
                        setSnackbarMessage('Please save your changes before proceeding.');
                        setSnackbarType('error');
                        return;
                    }
                    const response = yield api_1.binaryThreshold(binary_thresholding_data);
                    if (isMounted.current) {
                        if (response) {
                            setFeatureMapColumn(response.data.all_columns);
                            setEditError("");
                        }
                    }
                }
                else {
                    console.log("updatedMissingColumnData", updatedMissingColumnData);
                    if (projectInfo.problemtype === "anomalydetection") {
                        if (!validateFields("interpolate", 2)) {
                            console.log("Please select a valid field");
                            return;
                        }
                        if (typeof updatedInterpolateData.interpolationBase === "string") {
                            updatedInterpolateData.interpolationBase = [updatedInterpolateData.interpolationBase];
                        }
                        console.log("anomalydetection", updatedInterpolateData);
                        const interpolateData = {
                            projectname: projectInfo.projectname,
                            problemtype: projectInfo.problemtype,
                            version_name: projectInfo.version_name,
                            userid: js_cookie_1.default.get('USER_ID'),
                            interpolate_dataframe: {
                                interpolation_basecolumn: updatedInterpolateData.interpolationBase,
                                interpolation_frequency: updatedInterpolateData.interpolationFrequency,
                                label_column: updatedInterpolateData.labelColumn,
                                remove_rows: updatedInterpolateData.removeRows
                            }
                        };
                        const interpolateRes = yield api_1.interpolateDataset(interpolateData);
                        console.log("interpolateRes", interpolateRes);
                        dispatch(actions_1.saveInterpolationData(updatedInterpolateData));
                    }
                    const null_handling_data = {
                        projectname: projectInfo.projectname,
                        problemtype: projectInfo.problemtype,
                        version_name: projectInfo.version_name,
                        userid: js_cookie_1.default.get('USER_ID'),
                        handlingmissingvalues: {
                            categorical: {
                                remove_columns: updatedMissingColumnData.selectedCategoricalRemoveColumns,
                                replace_with_mode: updatedMissingColumnData.selectedCategoricalReplaceWithMode,
                                remove_rows: updatedMissingColumnData.selectedCategoricalRemoveRows
                            },
                            numerical: {
                                remove_columns: updatedMissingColumnData.selectedNumericalRemoveColumns,
                                replace_with_mode: updatedMissingColumnData.selectedNumericalReplaceWithMode,
                                replace_with_mean: updatedMissingColumnData.selectedNumericalReplaceWithMean,
                                replace_with_median: updatedMissingColumnData.selectedNumericalReplaceWithMedian,
                                replace_with_zero: updatedMissingColumnData.selectedNumericalReplaceWithZero,
                                remove_rows: updatedMissingColumnData.selectedNumericalRemoveRows
                            },
                            target: {
                                remove_columns: [],
                                replace_with_mode: updatedMissingColumnData.selectedTargetReplaceWithMode,
                                remove_rows: updatedMissingColumnData.selectedTargetRemoveRows
                            },
                            datetime: {
                                remove_columns: [],
                                remove_rows: updatedMissingColumnData.selectedDateTimeRemoveRows
                            },
                        }
                    };
                    dispatch(actions_1.saveHandlingMissingValues(updatedMissingColumnData));
                    let outlierRes = null;
                    if (!isVisualizeButton && projectInfo.problemtype !== "anomalydetection") {
                        outlierRes = yield api_1.handleMissingValues(null_handling_data);
                    }
                    if (projectInfo.problemtype === "regression") {
                        dispatch(actions_1.saveOutlierVisualizations(outlierRes.data.outlier_visualizations));
                    }
                    else if (projectInfo.problemtype !== "anomalydetection") {
                        if (outlierRes != null) {
                            dispatch(actions_1.saveOutlierVisualizations(outlierRes.data.graph_visualizations));
                        }
                    }
                    if (projectInfo.problemtype === "eventclassification") {
                        if (isVisualizeButton) {
                            console.log("the end");
                        }
                        else {
                            getVisualizationData();
                            setIsVisualizeButton(true);
                            window.scrollTo({ top: 0, behavior: 'smooth' });
                        }
                    }
                    if (projectInfo.problemtype === "RootCauseAnalysis") {
                        if (isVisualizeButton) {
                            console.log("the end");
                        }
                        else {
                            if (isMounted.current) {
                                setIsVisualizeButton(true);
                                setIsVisualizeTable(true);
                                setIsVisualizationFinal(true);
                            }
                        }
                    }
                }
            }
            else if (lastIndex === 3) {
                if (projectInfo.problemtype === "rca_ms") {
                    console.log("rca_ms step 4");
                    dispatch(actions_1.saveFeatureMappingData(updateFeatureMapping));
                    const feature_data = {
                        projectname: projectInfo.projectname,
                        problemtype: projectInfo.problemtype,
                        version_name: projectInfo.version_name,
                        userid: js_cookie_1.default.get('USER_ID'),
                        feature_mapping_data: updateFeatureMapping
                    };
                    if (columnNameError != "") {
                        setSnackbarOpen(true);
                        setSnackbarMessage('Please save your changes before proceeding.');
                        setSnackbarType('error');
                        return;
                    }
                    const response = yield api_1.featureMap(feature_data);
                    if (isMounted.current) {
                        setDataTransformColumn(response.data.final_unique_columns);
                        setIsVisualizeButton(true);
                    }
                    dispatch(actions_1.saveFinalUniqueColumns(response.data.final_unique_columns));
                }
                else {
                    console.log("step 4 done", outlierRemovalMethod);
                    if (projectInfo.problemtype === "anomalydetection") {
                        console.log("updatedMissingColumnData", updatedMissingColumnData);
                        const null_handling_data = {
                            projectname: projectInfo.projectname,
                            problemtype: projectInfo.problemtype,
                            version_name: projectInfo.version_name,
                            userid: js_cookie_1.default.get('USER_ID'),
                            handlingmissingvalues: {
                                remove_rows: updatedMissingColumnData.selectedNumericalRemoveRows,
                                replace_with_zero: updatedMissingColumnData.selectedNumericalReplaceWithZero,
                                replace_with_mode: updatedMissingColumnData.selectedNumericalReplaceWithMode,
                                replace_with_mean: updatedMissingColumnData.selectedNumericalReplaceWithMean,
                                replace_with_median: updatedMissingColumnData.selectedNumericalReplaceWithMedian,
                                replace_with_previous_value: updatedMissingColumnData.selectedNumericalReplaceWithPrevValue
                            }
                        };
                        const nullHandlingRes = yield api_1.handleMissingValues(null_handling_data);
                        console.log("nullHandlingRes", nullHandlingRes);
                        dispatch(actions_1.saveHandlingMissingValues(updatedMissingColumnData));
                    }
                    if (isVisualizeButton) {
                        console.log("the end");
                    }
                    else if (projectInfo.problemtype !== "anomalydetection") {
                        const outlier_removal_data = {
                            projectname: projectInfo.projectname,
                            problemtype: projectInfo.problemtype,
                            version_name: projectInfo.version_name,
                            userid: js_cookie_1.default.get('USER_ID'),
                            outlierremoval_method: {
                                timing: outlierRemovalMethod.timingColumns,
                                flooringandcapping: outlierRemovalMethod.floorAndCappingColumns,
                            }
                        };
                        const outlierRemovalRes = yield api_1.outlierRemoval(outlier_removal_data);
                        console.log("outlierRemovalRes", outlierRemovalRes.data);
                        getVisualizationData();
                        if (isMounted.current) {
                            setIsVisualizeButton(true);
                        }
                        window.scrollTo({ top: 0, behavior: 'smooth' });
                    }
                }
            }
            else if (lastIndex === 4) {
                console.log("lag variables", lagVariablesDataMain);
                if (!validateFields("lagVariables", 4)) {
                    console.log("Please select a valid field");
                    return;
                }
                const lagVariables = {
                    lagVariablesColumn: lagVariablesDataMain.lagVariablesColumn,
                    no_ofLagVariables: lagVariablesDataMain.no_ofLagVariables,
                    retainLabels: lagVariablesDataMain.retainLabels,
                };
                const lag_variables_data = {
                    projectname: projectInfo.projectname,
                    problemtype: projectInfo.problemtype,
                    version_name: projectInfo.version_name,
                    userid: js_cookie_1.default.get('USER_ID'),
                    createlagvariables: {
                        lag_var_column: lagVariablesDataMain.lagVariablesColumn,
                        no_of_lag_variables: lagVariablesDataMain.no_ofLagVariables,
                        retain_rows_labels: lagVariablesDataMain.retainLabels,
                    },
                };
                const lagVariablesRes = yield api_1.createLagVariables(lag_variables_data);
                console.log("lagVariablesRes", lagVariablesRes.data);
                if (projectInfo.problemtype === "anomalydetection") {
                    if (isVisualizeButton) {
                        console.log("the end");
                        getVisualizationData();
                    }
                    else {
                        getVisualizationData();
                        setIsVisualizeButton(true);
                    }
                }
                dispatch(actions_1.saveLagVariables(lagVariables));
            }
            if (lastIndex + 1 < subStepperData.length) {
                console.log("ffnsoifbduslfsd");
                let newSubStep = [...subStepperData];
                newSubStep[lastIndex + 1].active = true;
                if (isMounted.current) {
                    setSubStepData(newSubStep);
                }
                console.log("before", lastIndex);
                lastIndex = lastIndex + 1;
                console.log("lastinde", lastIndex);
            }
            else {
                if (isVisualizeButton) {
                    dispatch(actions_1.changeMainStep(mainStep + 1));
                    localStorage.setItem('pageFlag', 3);
                }
                else if (projectInfo.problemtype === "rca_ms") {
                    dispatch(actions_1.changeMainStep(mainStep + 1));
                    localStorage.setItem('pageFlag', 3);
                }
            }
            if (isMounted.current) {
                console.log("currext", isMounted);
                setCurrentStep(lastIndex);
            }
        }
        catch (error) {
            console.error("Error in increaseStep", error);
        }
        finally {
            if (isMounted.current) {
                setLoading(false);
            }
        }
    });
    const decreaseStep = () => {
        let lastIndex = 0;
        subStepperData.forEach((d, i) => {
            if (d.active === true) {
                lastIndex = i;
            }
        });
        if (lastIndex > 0) {
            let newSubStep = [...subStepperData];
            newSubStep[lastIndex].active = false;
            newSubStep[lastIndex - 1].active = true;
            setSubStepData(newSubStep);
            lastIndex = lastIndex - 1;
        }
        else {
            dispatch(actions_1.changeMainStep(mainStep - 1));
            localStorage.setItem('pageFlag', 1);
        }
        setCurrentStep(lastIndex);
        setIsVisualizeButton(false);
        setIsVisualizeTable(false);
        setIsVisualizationFinal(false);
    };
    const getVisualizationData = () => tslib_1.__awaiter(this, void 0, void 0, function* () {
        setLoading(true);
        const visualization_table_data = {
            projectname: projectInfo.projectname,
            problemtype: projectInfo.problemtype,
            version_name: projectInfo.version_name,
            userid: js_cookie_1.default.get('USER_ID'),
        };
        let visualizationRes = null;
        try {
            if (projectInfo.problemtype === "regression") {
                visualizationRes = yield api_1.visualizeOutlier(visualization_table_data);
            }
            else if (projectInfo.problemtype === "anomalydetection") {
                visualizationRes = yield api_1.visualizationAfterLagvariables(visualization_table_data);
                if (visualizationRes && visualizationRes.data && visualizationRes.data.visualization_data && visualizationRes.data.visualization_data[0]) {
                    let lagVariableColumns = Object.keys(visualizationRes.data.visualization_data[0])
                        .filter(key => key.includes('_lag'));
                    if (!Array.isArray(lagVariableColumns)) {
                        lagVariableColumns = Array.from(lagVariableColumns);
                    }
                    setUpdatedColumnData(prevData => (Object.assign({}, prevData, { lagVariablesColumnList: lagVariableColumns })));
                    dispatch(actions_1.saveColumnSelectionS22(updatedColumnData));
                }
                ;
            }
            else {
                visualizationRes = yield api_1.visualizeClassification(visualization_table_data);
            }
            if (visualizationRes.data.status === "success") {
                if (projectInfo.problemtype === "regression" || projectInfo.problemtype === "anomalydetection") {
                    setVisualizationTable(visualizationRes.data.visualization_data);
                }
                else {
                    setVisualizationImgs(visualizationRes.data.visualization_data);
                }
            }
        }
        catch (error) {
            console.error("Error in getVisualizationData", error);
        }
        finally {
            setLoading(false);
        }
    });
    const renderVisualizeTable = () => {
        setIsVisualizeTable(true);
        setIsVisualizationFinal(true);
    };
    return (react_1.default.createElement(core_1.Grid, { container: true },
        loading && (react_1.default.createElement("div", { style: {
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                backgroundColor: 'rgba(128, 128, 128, 0.7)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: 9999
            } },
            react_1.default.createElement(react_spinners_1.PropagateLoader, { color: "#3f51b5" }))),
        react_1.default.createElement(core_1.Grid, { item: true, xs: 12, sm: 12, md: 3, lg: 3 }),
        react_1.default.createElement(core_1.Grid, { item: true, xs: 12, sm: 12, md: 6, lg: 6, style: {
                textAlign: "center",
                paddingTop: "20px",
                paddingBottom: "20px",
            } }),
        react_1.default.createElement(core_1.Grid, { item: true, xs: 12, sm: 12, md: 3, lg: 3 }),
        react_1.default.createElement(core_1.Grid, { item: true, xs: 12, sm: 12, md: 3, lg: 3 }),
        react_1.default.createElement(core_1.Grid, { item: true, xs: 12, sm: 12, md: 6, lg: 6 }, subStepperData && react_1.default.createElement(sub_layout_1.SubLayout, { data: subStepperData, setCurrentStepByClick: setCurrentStepByClick, currentStep: currentStep })),
        react_1.default.createElement(core_1.Grid, { item: true, xs: 12, sm: 12, md: 3, lg: 3 }),
        react_1.default.createElement(core_1.Grid, { item: true, xs: 7, sm: 7, md: 7, lg: 7 }),
        react_1.default.createElement(core_1.Grid, { item: true, xs: 4, sm: 4, md: 4, lg: 4 },
            react_1.default.createElement("div", { style: { display: 'flex', justifyContent: 'flex-end' } }, isVisualizeButton && !isVisualizationFinal &&
                react_1.default.createElement(core_1.Button, { variant: "outlined", style: Object.assign({}, themes_1.nextBotton, { width: '50%' }), onClick: () => renderVisualizeTable() }, "Visualization")),
            !isVisualizeButton && !isVisualizationFinal && ((currentStep === 3 && (projectInfo.problemtype === "regression")) || (currentStep === 4 && projectInfo.problemtype === "anomalydetection")) &&
                react_1.default.createElement(core_1.Typography, { className: styleLocal.errorText },
                    react_1.default.createElement(Icons_1.LockIcon, null),
                    projectInfo.problemtype === "regression" ? "Complete the Outlier Removal to show Visualize Table" : "")),
        react_1.default.createElement(core_1.Grid, { item: true, xs: 1, sm: 1, md: 1, lg: 1 }),
        react_1.default.createElement(core_1.Grid, { item: true, xs: 12, sm: 12, md: 1, lg: 1 }),
        react_1.default.createElement(core_1.Grid, { item: true, xs: 12, sm: 12, md: 10, lg: 10, style: { paddingTop: "30px" } },
            currentStep === 0 && react_1.default.createElement(pre_processing_step1_1.PreProcessingStep1, { projectInfo: projectInfo }),
            currentStep === 1 && react_1.default.createElement(pre_processing_step2_1.PreProcessingStep2, { setUpdatedColumnData: setUpdatedColumnData, errorMessage: errorMessage, setErrorMessage: setErrorMessage, remainingColumnError: remainingColumnError, setRemainingColumnError: setRemainingColumnError }),
            currentStep === 2 && projectInfo.problemtype !== "anomalydetection" && projectInfo.problemtype !== "rca_ms" && react_1.default.createElement(pre_processing_step3_1.PreProcessingStep3, { setUpdatedMissingColumnData: setUpdatedMissingColumnData, isVisualizeTable: isVisualizeTable, visualizationImgs: visualizationImgs, problemtype: projectInfo.problemtype, isVisualizationFinal: isVisualizationFinal, isVisualizeButton: isVisualizeButton }),
            currentStep === 3 && projectInfo.problemtype !== "anomalydetection" && projectInfo.problemtype !== "rca_ms" && react_1.default.createElement(pre_processing_step4_1.PreProcessingStep4, { setOutlierRemovalMethod: setOutlierRemovalMethod, isVisualizeTable: isVisualizeTable, visualizationTable: visualizationTable }),
            currentStep === 2 && projectInfo.problemtype === "anomalydetection" && react_1.default.createElement(pre_processing_step3_Anomaly_1.PreprocessingStep3AnomalyDetection, { interpolationFrequencyError: interpolationFrequencyError, setUpdatedInterpolateData: setUpdatedInterpolateData }),
            currentStep === 2 && projectInfo.problemtype === "rca_ms" && react_1.default.createElement(pre_processing_step3_rca_ms_1.PreprocessingStep3RCAMultistep, { setBinaryThresholding: setBinaryThresholding, configureColumnValue: configureColumnValue, setErrorMessage: setErrorMessage, errorMessage: errorMessage, categoricalColumn: categoricalColumn, setEditingRowId: setEditingRowId, editingRowId: editingRowId, editError: editError, setEditError: setEditError }),
            currentStep === 3 && projectInfo.problemtype === "anomalydetection" && react_1.default.createElement(pre_processing_step4_Anomaly_1.PreprocessingStep4AnomalyDetection, { setUpdatedMissingColumnData: setUpdatedMissingColumnData }),
            currentStep === 3 && projectInfo.problemtype === "rca_ms" && react_1.default.createElement(pre_processing_step4_rca_ms_1.PreprocessingStep4RCAMultistep, { setFeatureMapping: setFeatureMapping, featureMapColumn: featureMapColumn, columnNameError: columnNameError, setColumnNameError: setColumnNameError }),
            currentStep === 4 && projectInfo.problemtype === "anomalydetection" && react_1.default.createElement(pre_processing_step5_Anomaly_1.PreprocessingStep5AnomalyDetection, { lagVariablesCountError: lagVariablesCountError, lagVariablesColumnError: lagVariablesColumnError, setLagVariablesDataMain: setLagVariablesDataMain, isVisualizeTable: isVisualizeTable, visualizationTable: visualizationTable })),
        react_1.default.createElement(core_1.Grid, { item: true, xs: 12, sm: 12, md: 1, lg: 1 }),
        react_1.default.createElement(core_1.Grid, { item: true, xs: 12, sm: 12, md: 7, lg: currentStep === 1 ? 6 : 7 }),
        react_1.default.createElement(core_1.Grid, { item: true, xs: 12, sm: 12, md: 4, lg: 4 },
            react_1.default.createElement("div", { style: { width: "100%", textAlign: currentStep === 1 ? "left" : "right" } },
                react_1.default.createElement(core_1.Button, { variant: "outlined", style: themes_1.cancelBotton, onClick: () => decreaseStep() }, "Previous"),
                react_1.default.createElement(core_1.Button, { style: Object.assign({}, themes_1.nextBotton, { backgroundColor: (isVisualizeButton && !isVisualizationFinal) ? 'gray' : themes_1.nextBotton.backgroundColor }), onClick: () => increaseStep(), disabled: (isVisualizeButton && !isVisualizationFinal) }, "Next"))),
        react_1.default.createElement(core_1.Grid, { item: true, xs: 12, sm: 12, md: 1, lg: 1 }),
        react_1.default.createElement(core_1.Snackbar, { open: snackbarOpen, autoHideDuration: 3000, onClose: handleCloseSnackbar, anchorOrigin: { vertical: "bottom", horizontal: "right" }, style: { maxWidth: "60%" } },
            react_1.default.createElement(lab_1.Alert, { onClose: handleCloseSnackbar, severity: snackbarType, variant: "filled", sx: { width: '100%' } }, snackbarMessage))));
}
exports.PreProcessing = PreProcessing;
//# sourceMappingURL=pre-processing.js.map